import { createTransport } from '@sentry/browser'

const SUCCESS = { statusCode: 200 }

const parseEnvelope = (body) => {
  const text = typeof body === 'string'
    ? body
    : new TextDecoder().decode(body)
  return text.split('\n').filter(Boolean)
}

const toGelf = (payload) => {
  const exception = payload.exception?.values?.[0]
  const frames = exception?.stacktrace?.frames || []
  const top = frames[frames.length - 1]
  const tags = payload.tags || {}
  const user = payload.user || {}
  const error_type = exception?.type || payload.message || 'Error'
  const error_message = exception?.value || payload.message || ''
  return {
    version: '1.1',
    host: 'admin',
    short_message: `${error_type}: ${error_message}`.slice(0, 250),
    timestamp: payload.timestamp || (Date.now() / 1000),
    level: 3,
    _client: 'frontend',
    _hostname: window.location.hostname,
    _user_agent: window.navigator.userAgent,
    _url: payload.request?.url || window.location.href,
    _release: payload.release,
    _environment: payload.environment,
    _event_id: payload.event_id,
    _error_type: exception?.type,
    _error_message: exception?.value,
    _file: top?.filename,
    _line: top?.lineno,
    _column: top?.colno,
    _function: top?.function,
    _fingerprint: payload.fingerprint?.join(':'),
    _stack_trace: JSON.stringify(frames.slice(-10)),
    _breadcrumbs: JSON.stringify(
      Array.isArray(payload.breadcrumbs?.values) ? payload.breadcrumbs.values.slice(-10)
        : Array.isArray(payload.breadcrumbs) ? payload.breadcrumbs.slice(-10)
          : []
    ),
    _user_id: user.id,
    _user_email: user.email,
    _user_name: user.username,
    _team: tags.team,
    _source_ip: tags.source_ip,
    _request_id: tags.request_id
  }
}

export const graylogTransport = (options) => {
  return createTransport(options, async (request) => {
    if(process.env.MAHA_ENV !== 'production') return SUCCESS

    const pieces = parseEnvelope(request.body)
    const messages = []

    // Sentry envelope: [envelope_header]\n[item_header]\n[item_payload]\n...
    try {
      for(let i = 1; i < pieces.length; i += 2) {
        const itemHeader = JSON.parse(pieces[i])
        if(itemHeader.type !== 'event') continue
        const payload = JSON.parse(pieces[i + 1])
        messages.push(toGelf(payload))
      }
    } catch(error) {
      return SUCCESS
    }

    if(messages.length === 0) return SUCCESS

    const tld = window.location.hostname.split('.').slice(-2).join('.')
    try {
      await fetch(`https://telemetry.${tld}/gelf`, {
        method: 'POST',
        body: messages.map((m) => JSON.stringify(m)).join('\r\n') + '\r\n',
        keepalive: true
      })
    } catch(error) {
      // best-effort delivery
    }

    return SUCCESS
  })
}

export default graylogTransport
